import * as React from "react";
import ModelContainer from "../../../components/model/ModelContainer";
import PageTitle from "../../../components/model/PageTitle";
import ModelTitle from "../../../components/model/ModelTitle";
import ModelInfo from "../../../components/model/ModelInfo";
import {GAEventModels} from "../../../utils/SendGAEvent";
import ModelDescription from "../../../components/model/ModelDescription";
import {Icon} from "bloomer";
import QuestionAnsweringModel from "./QuestionAnsweringModel";
import Disclaimer from "../../../components/model/Disclaimer";
import TabPanel from "../../../components/model/TabPanel";

const QuestionAnswering = () => {
    return <ModelContainer>
        <PageTitle/>
        <div>
            <ModelTitle>Question Answering</ModelTitle>
            <ModelInfo model={GAEventModels.QUESTION_ANSWERING}/>
            <TabPanel
                modelName={GAEventModels.QUESTION_ANSWERING}
                modelDescription={<ModelDescription>
                    <ul>
                        <p>The model answers the question based on the context. The maximum sizes of inputs are:</p>
                        <li><Icon className="fas fa-circle" style={{fontSize: '8px'}}/> 1000 words for context;</li>
                        <li><Icon className="fas fa-circle" style={{fontSize: '8px'}}/> 50 words for the question.</li>
                    </ul>
                </ModelDescription>}
                content={<QuestionAnsweringModel/>}
            />
            <Disclaimer/>
        </div>
    </ModelContainer>;
};

export default QuestionAnswering;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/QuestionAnswering/index.tsx